// Basit göreli zaman ("3 dk önce" / "3 min ago")
export function timeAgo(date, lang = 'tr') {
  if (!date) return lang === 'tr' ? 'hiç' : 'never';
  const diff = Date.now() - new Date(date).getTime();
  const sec = Math.round(diff / 1000);
  const min = Math.round(sec / 60);
  const hr = Math.round(min / 60);
  const day = Math.round(hr / 24);
  const tr = lang === 'tr';
  if (sec < 45) return tr ? 'az önce' : 'just now';
  if (min < 60) return tr ? `${min} dk önce` : `${min} min ago`;
  if (hr < 24) return tr ? `${hr} sa önce` : `${hr} h ago`;
  return tr ? `${day} gün önce` : `${day} d ago`;
}

export function formatDateTime(date, lang = 'tr') {
  if (!date) return '—';
  return new Date(date).toLocaleString(lang === 'tr' ? 'tr-TR' : 'en-GB', {
    day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit',
  });
}
